import { Component, OnInit } from '@angular/core';
import { ParametrizacionService } from 'src/app/open-api';
import { EMPTY_STRING } from 'src/app/shared/utils/regular-expresions';

@Component({
  selector: 'app-contacto-whatsapp',
  templateUrl: './contacto-whatsapp.component.html',
  styleUrls: ['./contacto-whatsapp.component.scss'],
})
export class ContactoWhatsappComponent implements OnInit {
  numeroCelular = EMPTY_STRING;

  constructor(private parametrizacionService: ParametrizacionService) {}

  ngOnInit(): void {
    this.parametrizacionService
      .apiV10ParametrizacionObtenerParametrizacionEmpresaContactoGet()
      .subscribe((respuesta) => {
        this.numeroCelular = respuesta.numeroContactCenter || EMPTY_STRING;
      });
  }
}
